import { getApiClient } from "@punchup/utils/apiRegistry";
import {
  NotificationPreferences,
  NotificationPreferenceUpdatePayload,
} from "@punchup/data/models";

export type UserNotificationPreferencesResponse = {
  preferences: NotificationPreferences | null;
};

/**
 * Fetches the notification preferences for the authenticated user
 * @returns The user's notification preferences or null if not found
 */
export async function getUserNotificationPreferences(): Promise<NotificationPreferences | null> {
  const response = await getApiClient().get<{
    data: UserNotificationPreferencesResponse;
  }>("/api/v2/user/notification-preferences");

  return response.data.preferences;
}

/**
 * Updates the notification preferences for the authenticated user
 * @param payload - The partial notification preferences to update
 * @returns The updated notification preferences or null if update failed
 */
export async function updateNotificationPreferences(
  payload: Partial<NotificationPreferenceUpdatePayload>
): Promise<NotificationPreferences | null> {
  const response = await getApiClient().patch<{
    data: UserNotificationPreferencesResponse;
  }>("/api/v2/user/notification-preferences", payload);

  return response.data.preferences;
}
